import { useEffect, useState } from 'react';
import { Table, TableProps } from 'antd';

interface Props extends TableProps<any> {
  updateTablePagination: any,
  columns: Object[],
  dataSource: Object[],
  totalMemberResults: number;
}

const SubmittedClaimsTable = (props: Props) => {

  const DEFAULT_PAGE_NUM = 1;
  const DEFAULT_PAGE_SIZE = 20;
  const [page, setPage] = useState(DEFAULT_PAGE_NUM);

  useEffect(() => {
    setPage(DEFAULT_PAGE_NUM);
  }, [props.dataSource]);

  return (
    <Table
      {...props}
      columns={props.columns}
      dataSource= {props.dataSource}
      pagination={{
        current: page,
        position: ['bottomCenter'], 
        showSizeChanger: true, 
        defaultPageSize: DEFAULT_PAGE_SIZE, 
        total: props.totalMemberResults, 
        hideOnSinglePage: true,
        onChange: (num: number) => {
          setPage(num);
        }
      }}
      onChange={(state) => {
        props.updateTablePagination({...state});
      }}
      rowKey={'RmiMembId'}
    />
  );
}

export default SubmittedClaimsTable;